var React = require('react');

function IcShareFbDark (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M26.63 13.64h-3.323c-.392 0-.83.515-.83 1.207v2.398h4.152v3.42h-4.152v10.267h-3.922V20.665H15v-3.42h3.555v-2.012c0-2.886 2.003-5.233 4.752-5.233h3.323v3.64z","fill":"currentColor"}));
}

IcShareFbDark.defaultProps = {"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none"};

module.exports = IcShareFbDark;

IcShareFbDark.default = IcShareFbDark;
